<template>
  <div>
    <button class="map-filter-toggler" @click="toggleVisibility">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="20"
        viewBox="0 0 24 20"
      >
        <g fill="#1b5761" fill-rule="evenodd">
          <path
            d="M6.38 1.724c.665 0 1.206.542 1.206 1.207 0 .666-.541 1.207-1.207 1.207A1.208 1.208 0 0 1 5.172 2.93c0-.665.542-1.207 1.207-1.207m-2.787 2.07A2.925 2.925 0 0 0 6.38 5.861a2.925 2.925 0 0 0 2.787-2.069H23.18c.475 0 .8-.386.8-.862s-.325-.862-.8-.862H9.166A2.925 2.925 0 0 0 6.38 0a2.925 2.925 0 0 0-2.787 2.069H.862a.862.862 0 0 0 0 1.724h2.73zM17.414 11.034a1.208 1.208 0 0 1-1.207-1.206c0-.666.541-1.207 1.207-1.207.665 0 1.207.541 1.207 1.207 0 .665-.542 1.206-1.207 1.206m5.517-2.068h-2.73a2.925 2.925 0 0 0-2.787-2.07 2.925 2.925 0 0 0-2.787 2.07H.862a.862.862 0 0 0 0 1.724h13.765a2.925 2.925 0 0 0 2.787 2.069 2.925 2.925 0 0 0 2.787-2.07h2.911a.862.862 0 0 0 0-1.723M9.138 17.931a1.208 1.208 0 0 1-1.207-1.207c0-.665.541-1.207 1.207-1.207.665 0 1.207.542 1.207 1.207 0 .666-.542 1.207-1.207 1.207m13.793-2.069H11.925a2.925 2.925 0 0 0-2.787-2.069 2.925 2.925 0 0 0-2.787 2.07H.862a.862.862 0 0 0 0 1.723h5.489a2.925 2.925 0 0 0 2.787 2.07 2.925 2.925 0 0 0 2.787-2.07h11.15a.862.862 0 0 0 0-1.724"
          />
        </g>
      </svg>
      <span>{{ texts.filterText }}</span>
    </button>
    <div class="map-filter-wrapper">
      <div class="map-filter" :class="{ visible: visible }">
        <div class="filter-content">
          <FilterOption
            v-for="(option, index) in filterOptions"
            :key="index"
            v-bind="option"
            :checked-list="checkedList"
            @updateKey="updateKey"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterOption from './FilterOption.vue';

export default {
  name: 'MapFilter',

  components: {
    FilterOption,
  },

  props: {
    filterOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    checkedList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      visible: false,
      texts: theme_vars.mapText,
    };
  },

  computed: {
    indentifier() {
      return `search-filter-item-${this.type}`;
    },
  },

  methods: {
    updateKey(key) {
      this.$emit('updateCheckedList', key);
    },

    toggleVisibility() {
      this.visible = !this.visible;
    },
  },
};
</script>
